import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { ActiveCoverage } from '@lib/insurance-packages/data-access';
import { selectMemberActiveCoverage } from '@lib/members/data-access';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { formatDate } from '@lib/commons/util-functions/format-date.function';

import { ModalHeaderComponent } from '@lib/shared-ui/components/layout';

import { PackageCoverageComponent } from '../package-coverage/package-coverage.component';

export interface PackageCoverageDialogData {
  userId: string;
}

@Component({
  selector: 'members-package-coverage-dialog',
  standalone: true,
  imports: [ModalHeaderComponent, PackageCoverageComponent, MatIcon, MatTooltip, TranslatePipe],
  templateUrl: './package-coverage-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageCoverageDialogComponent {
  private readonly store = inject(Store);
  protected readonly data = inject<PackageCoverageDialogData>(MAT_DIALOG_DATA);

  private readonly activeCoverage = this.store.selectSignal(selectMemberActiveCoverage);

  protected readonly coverage = computed<ActiveCoverage | null>(() => {
    const coverage = this.activeCoverage().coverage;
    return coverage?.userId === this.data.userId ? (coverage.data ?? null) : null;
  });

  protected readonly formatDate = formatDate;
}
